// TILEN 3/10: julepyntens mængderabat følger kurven.
// Rabatten er en variant ("3+ stk."), som produktsiden vælger ud fra antallet. Ændres antallet i kurven,
// eller lægges pynt i som flere linjer, passer varianten ikke længere. Efter hver ændring af kurven tælles
// al julepynt sammen: fra 3 stk. skal alle julepynt-linjer være "3+ stk.", ellers "1-2 stk.".
// En linje med forkert variant lægges i igen med den rigtige. Er antallet sat ned, fjernes de sidste navne
// (Pynt N), så ordren kun har ét navn pr. pynt. Antallet kan ikke sættes op i kurven (max i kurvens felt).
(function () {
  // Kun én kopi må lytte, ellers lægges pynten i to gange.
  if (window.tilenJulepyntKurv) return;
  window.tilenJulepyntKurv = true;
  var HANDLE = 'julepynt-med-navn';
  var varianter = null;
  var koerer = false;
  var igen = false;

  function post(url, data) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(data),
    }).then(function (r) {
      if (!r.ok) throw new Error(url + ' ' + r.status);
      return r.json();
    });
  }

  function hentVarianter() {
    if (varianter) return Promise.resolve(varianter);
    var rod = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    return fetch(rod + 'products/' + HANDLE + '.js')
      .then(function (r) { return r.json(); })
      .then(function (p) {
        var v = {};
        p.variants.forEach(function (x) {
          if (x.option1 === '1-2 stk.') v.en = x.id;
          if (x.option1 === '3+ stk.') v.tre = x.id;
        });
        if (!v.en || !v.tre) throw new Error('julepynt: varianterne "1-2 stk." og "3+ stk." findes ikke');
        varianter = v;
        return v;
      });
  }

  // Navnenøglerne "Pynt 1".."Pynt N" i rækkefølge.
  function navne(props) {
    return Object.keys(props || {})
      .filter(function (k) { return /^Pynt \d+$/.test(k); })
      .sort(function (a, b) { return parseInt(a.slice(5), 10) - parseInt(b.slice(5), 10); });
  }

  function afstem() {
    if (koerer) { igen = true; return; }
    koerer = true;
    fetch(window.routes.cart_url + '.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var linjer = cart.items.filter(function (i) { return i.handle === HANDLE; });
        if (!linjer.length) return false;
        return hentVarianter().then(function (v) {
          var total = linjer.reduce(function (s, i) { return s + i.quantity; }, 0);
          var maal = total >= 3 ? v.tre : v.en;
          var forkerte = linjer.filter(function (i) {
            return i.variant_id !== maal || navne(i.properties).length > i.quantity;
          });
          if (!forkerte.length) return false;
          // Én linje ad gangen: læg først den rettede linje i, fjern derefter den gamle (så en fejl aldrig tømmer kurven).
          return forkerte.reduce(function (kaede, i) {
            return kaede.then(function () {
              var props = {};
              Object.keys(i.properties || {}).forEach(function (k) { props[k] = i.properties[k]; });
              navne(i.properties).slice(i.quantity).forEach(function (k) { delete props[k]; });
              return post(window.routes.cart_add_url + '.js', {
                items: [{ id: maal, quantity: i.quantity, properties: props }],
              }).then(function () {
                return post(window.routes.cart_change_url + '.js', { id: i.key, quantity: 0 });
              });
            });
          }, Promise.resolve()).then(function () { return true; });
        });
      })
      .then(function (aendret) { if (aendret) vis(); })
      .catch(function (e) { console.error(e); })
      .finally(function () {
        koerer = false;
        if (igen) { igen = false; afstem(); }
      });
  }

  // Vis de nye priser: kurvsiden genindlæses, skuffen henter sig selv igen.
  function vis() {
    if (document.querySelector('cart-items')) { window.location.reload(); return; }
    var skuffe = document.querySelector('cart-drawer-items');
    if (skuffe && typeof skuffe.onCartUpdate === 'function') skuffe.onCartUpdate();
  }

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') subscribe(PUB_SUB_EVENTS.cartUpdate, afstem);
  // En kurv, der allerede har julepynt, når siden åbnes (fx efter tilbage-knappen).
  if (document.querySelector('[data-tilen-jul]')) afstem();
})();
